<div class="p-4">
  <h1 class="leading-8 mb-1">Activity</h1>
  <p class="leading-5">Check your activities based on login devices and locations.</p>
  <mat-divider class="!mt-4 !mb-8"></mat-divider>

  <mat-progress-bar mode="indeterminate" *ngIf="loading" class="progress-bar"></mat-progress-bar>
  <div class="detail flex flex-col gap-2" *ngIf="!loading">
    <div class="title flex items-center" *ngIf="hasOtherSessions">
      <div class="title__header flex flex-col">
        <h2>Recent login</h2>

        <p *ngIf="!signoutSuccessful">There may be sessions that have not been signed out.</p>

        <p *ngIf="signoutSuccessful">
          <strong>Note:</strong> Users can log in again if they know your password or have it saved on their computer.
          If you are concerned about someone using your account without your permission, please.
          <a href="javascript:void(0)" (click)="gotoPasswordSettings()">change your password</a>.
        </p>
      </div>

      <button *ngIf="!signoutSuccessful" mat-stroked-button [loading]="signingOut" (click)="signOutOtherLoginSession()">
        Sign out all other web sessions
      </button>
    </div>

    <div class="px-4 bg-white mat-elevation-z1">
      <table mat-table [dataSource]="ui.currentActivities">
        <ng-container matColumnDef="device">
          <th mat-header-cell *matHeaderCellDef>Device</th>
          <td mat-cell *matCellDef="let item">{{ item['Device Type'] }}</td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Location (IP address)</th>
          <td mat-cell *matCellDef="let item">
            <b *ngIf="currentIpAddress === item['IP Address']">*</b> {{ item.Country }} ({{ item['IP Address'] }})
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item">
            <div class="flex items-center gap-2">
              <span class="status" [ngClass]="item.Successful === 'Yes' ? 'successful' : 'failed'">{{
                (item.Successful === 'Yes' ? 'Successful' : 'Failed') | capitalizeCase
              }}</span>
              <mat-icon
                *ngIf="!(item.Successful === 'Yes')"
                [matTooltip]="item['Failed Reason'] | sentenceCase: '_' | titlecase"
                mat-icon-button
                class="status-info"
              >
                info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef>Completion time</th>
          <td mat-cell *matCellDef="let item">{{ item['Duration'] ?? '0ms' }}</td>
        </ng-container>

        <ng-container matColumnDef="datetime">
          <th mat-header-cell *matHeaderCellDef>Login time</th>
          <td mat-cell *matCellDef="let item">{{ item['Date Time'] | userDate }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-toolbar>
        <mat-toolbar-row class="flex justify-between !px-0">
          <div class="reminder" *ngIf="currentIpAddress">
            * indicates login from the current IP address {{ currentIpAddress }}. ({{ currentCountry }})
          </div>

          <div class="footer-table flex justify-end items-center mx-4">
            <button mat-icon-button [disabled]="ui.paging.page === 1 || fetching" (click)="prevPage()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span mat-mini-fab>
              {{ ui.paging.page }}
            </span>
            <button
              mat-icon-button
              [disabled]="!ui.backUpNext || ui.backUpNext.length === 0 || fetching"
              (click)="nextPage()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  </div>
</div>
